/* eslint-disable */
import { FormControl, Grid, Input, ListItemText, MenuItem, Select, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import CustomUploadField from '../shared/CustomUploadField';
import { DIMENSIONS } from '../../constants/aspectRatio';
import { ErrorToast } from '../utils/Utils';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const useStyle = makeStyles({
  certBox: {
    height: '60vh',
    overflowY: 'auto',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '10px 20px',
  },
  header: {
    width: '98%',
    display: 'flex',
    alignItems: 'center',
  },
  heading: {
    color: '#10182B',
    fontSize: '18px',
    fontWeight: '700',
  },
  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  inputField: {
    width: '95%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
  },
  upload: {
    border: '1px solid #E4E7EC',
    padding: '7px',
    marginTop: '5px',
    width: '96%',
    borderRadius: '5px',
    background: '#FEFEFE',
  },
  popupLabels: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  popInputs: {
    border: 0,
    outline: 0,
    backgroundColor: '#fff',
    height: '45px',
    width: '98%',
    padding: '0 10px',
    marginLeft: '0px',
    marginTop: '10px',
    marginBottom: '20px',
    '&:placeholder': {
      color: '#4b4b4b',
      opacity: '1',
    },
  },
});

export const AddIssuer = ({
  issuerName,
  setIssuerName,
  setIssuerIcon,
  issuerIcon,
  setIssuerLogo,
  issuerLogo,
  stLogoUrl,
  setIconUrl,
  iconUrl,
  logoUrl,
  isEdit,
  issuerId,
  selectedRnp,
  setSelectedRnp,
}) => {
  const classes = useStyle();
  const dispatch = useDispatch();

  const [issuerInfo, setIssuerInfo] = useState({});
  const [rnpList, setRnpList] = useState([]);

  const getIssuer = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.CERT_ISSUER_INFO.replace('ID', issuerId));
      setIssuerInfo(res || {});
      setSelectedRnp(res.rockedNetworkPartnerId);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const getRnp = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.CERT_RNP_LIST);
      setRnpList(res);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (isEdit) {
      getIssuer();
    } else {
      setIssuerName('');
      setIssuerIcon(null);
      setIssuerLogo(null);
      stLogoUrl('');
      setIconUrl('');
      setSelectedRnp(null);
    }
    getRnp();
  }, []);

  useEffect(() => {
    if (isEdit) {
      setIssuerName(issuerInfo.name);
      stLogoUrl(issuerInfo.logo);
      setIconUrl(issuerInfo.icon);
      setIssuerIcon(null);
      setIssuerLogo(null);
    }
  }, [issuerInfo]);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    setIssuerLogo(file);
    const reader = new FileReader();
    reader.onload = (ev) => {
      stLogoUrl(ev.target.result);
    };
    reader.readAsDataURL(file);
  };

  const handleDeleteLogo = () => {
    setIssuerLogo(null);
    stLogoUrl('');
  };

  const handleIconChange = (e) => {
    const file = e.target.files[0];
    setIssuerIcon(file);
    const reader = new FileReader();
    reader.onload = (ev) => {
      setIconUrl(ev.target.result);
    };
    reader.readAsDataURL(file);
  };

  const handleDeleteIcon = () => {
    setIssuerIcon(null);
    setIconUrl('');
  };

  const handleRnp = (e) => {
    setSelectedRnp(e.target.value);
  };
  return (
    <Grid className={classes.certBox}>
      <Grid className={classes.header}>
        <Typography className={classes.heading}> {isEdit ? 'Edit Issuer' : 'Add Issuer'} </Typography>
      </Grid>

      <Grid style={{ width: '100%' }}>
        <Grid style={{ display: 'flex', width: '97%', justifyContent: 'space-between' }}>
          <Typography className={classes.required_field}>Issuer Name </Typography>
        </Grid>
        <input
          placeholder="Enter issuer name"
          className={classes.inputField}
          value={issuerName}
          onChange={(e) => setIssuerName(e.target.value)}
        />
      </Grid>

      <Grid>
        <Typography className={classes.required_field}>Issuer Logo (to be displayed on the certificate) </Typography>
        <CustomUploadField
          type="image"
          name="issuer-logo"
          value={issuerLogo ? logoUrl : null}
          imgSrc={!issuerLogo ? logoUrl : null}
          handleChange={handleLogoChange}
          customStyles={{ width: '100%' }}
          fileName={issuerLogo?.name}
          dimensions={DIMENSIONS.issuerLogo}
          handleDelete={handleDeleteLogo}
        />
      </Grid>

      <Grid>
        <Typography className={classes.required_field}>Issuer Icon </Typography>
        <CustomUploadField
          type="image"
          name="issuer-icon"
          value={issuerIcon ? iconUrl : null}
          imgSrc={!issuerIcon ? iconUrl : null}
          handleChange={handleIconChange}
          customStyles={{ width: '100%' }}
          fileName={issuerIcon?.name}
          dimensions={DIMENSIONS.issuerIcon}
          handleDelete={handleDeleteIcon}
        />
      </Grid>

      <Grid item>
        <div className={classes.popupLabels}>
          <label className={classes.required_field}>Partner</label>
        </div>
        <FormControl style={{ marginTop: '5px', width: '100%' }}>
          <Select
            name="rnp"
            labelId="multiple-checkbox-label"
            id="multiple-checkbox"
            value={selectedRnp}
            onChange={handleRnp}
            input={<Input disableUnderline className={classes.popInputs} />}
            MenuProps={MenuProps}
          >
            {rnpList?.map((option) => (
              <MenuItem key={option.id} name={option.id} value={option.id}>
                <ListItemText primary={option.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};
